import React from 'react';
import ReactSelect, {
  Props as ReactSelectProps,
  OptionTypeBase,
} from 'react-select';

import { Container, ErrorMessage, reactSelectStyles } from './styles';

export type SelectProps = ReactSelectProps<OptionTypeBase> & {
  label?: string;
  error?: string;
};

export type SelectOptionType = {
  value: number;
  label: string;
};

const Select: React.ForwardRefRenderFunction<any, SelectProps> = (
  { id, label, error, ...rest },
  ref,
) => {
  return (
    <Container>
      {label && <label htmlFor={id}>{label}</label>}
      <ReactSelect
        id={id}
        ref={ref}
        styles={reactSelectStyles}
        noOptionsMessage={() => 'Nenhuma opção'}
        placement="top"
        menuPosition="absolute"
        {...rest}
      />
      <ErrorMessage>{error}</ErrorMessage>
    </Container>
  );
};

export default React.forwardRef(Select);
